import { API, graphqlOperation } from "aws-amplify";
import moment from "moment";
import envFile from "../envFile";

import { getRdsData, getSignedUrl, listLambdaResolver, validateTenant } from "../graphql/queries";
import { addUserToGroup, createLambdaResolver, updateLambdaResolver,  crudCommunications } from "../graphql/mutations";
import { getId } from ".";
import axios from "axios";
import { accessToken } from ".";

export const getRdsFN = async (name, payload) => {
  if (name === "tbSelect") {
    payload = { ...payload, act: 1 };
  }
  return API.graphql(
    graphqlOperation(getRdsData, {
      name: name,
      data: JSON.stringify(payload),
    })
  ).then((res) => JSON.parse(res.data.getRdsData.response));
};

export const createRecordTB = async (tblName, payload) => {
  return API.graphql(
    graphqlOperation(createLambdaResolver, {
      table: tblName,
      data: JSON.stringify(payload),
    })
  ).then((res) => {
    const res1 = res.data.createLambdaResolver;
    if (res1.status === 200) {
      return JSON.parse(res1.response);
    } else {
      throw { message: res1.response };
    }
  });
};

export const updateRecordTB = async (tblName, payload) => {
  return API.graphql(
    graphqlOperation(updateLambdaResolver, {
      table: tblName,
      data: JSON.stringify(payload),
    })
  ).then((res) => {
    const res1 = res.data.updateLambdaResolver;
    if (res1.status === 200) {
      return JSON.parse(res1.response);
    } else {
      throw { message: res1.response };
    }
  });
};
export const getUnityPropertyDetails = async ({ propertyUnitID }) => {
  return API.graphql(
    graphqlOperation(getRdsData, {
      name: "tpPropertyDetail",
      data: JSON.stringify({ propertyUnitId: propertyUnitID }),
    })
  ).then(async (res) => {
    const parsedResponse = JSON.parse(res.data.getRdsData.response);
    return parsedResponse;
  });
};

export const getTenantBankMaskedNo = async ({ tenantId }) => {
  return API.graphql(
    graphqlOperation(getRdsData, {
      name: "tpTenantBankMaskedNo",
      data: JSON.stringify({ tenantId: tenantId }),
    })
  ).then(async (res) => {
    const parsedResponse = JSON.parse(res.data.getRdsData.response);
    return parsedResponse;
  });
};

export const getTransactions = async ({ tenantId, endDate, startDate }) => {
  const formatedStartDate = moment(startDate).format("YYYY-MM-DD");
  const formatedEndDate = moment(endDate).format("YYYY-MM-DD");
  return API.graphql(
    graphqlOperation(getRdsData, {
      name: "tpTransactions",
      data: JSON.stringify({ tenantId: tenantId, startDate: formatedStartDate, endDate: formatedEndDate }),
    })
  ).then(async (res) => {
    const parsedResponse = JSON.parse(res.data.getRdsData.response);
    return parsedResponse;
  });
};

export const fetchAllBankAccounts = async ({ tenant_id }) => {
  return API.graphql(
    graphqlOperation(getRdsData, {
      name: "tpBankAccounts",
      data: JSON.stringify({ tenantId: tenant_id }),
    })
  ).then(async (res) => {
    const parsedResponse = JSON.parse(res.data.getRdsData.response);
    return parsedResponse;
  });
};
export const fetchTpLeaseBankAccounts = async ({ tenant_id }) => {
  return API.graphql(
    graphqlOperation(getRdsData, {
      name: "tpLeaseBankAccounts",
      data: JSON.stringify({ tenantId: tenant_id }),
    })
  ).then(async (res) => {
    const parsedResponse = JSON.parse(res.data.getRdsData.response);
    return parsedResponse;
  });
};
export const fetchFuturePayments = async ({ tenant_id }) => {
  return API.graphql(
    graphqlOperation(getRdsData, {
      name: "tpUpcomingPayments",
      data: JSON.stringify({ tenantId: tenant_id }),
    })
  ).then(async (res) => {
    const parsedResponse = JSON.parse(res.data.getRdsData.response);
    return parsedResponse;
  });
};

export const fetchDashboardData = async (tenant_id) => {
  return API.graphql(
    graphqlOperation(getRdsData, {
      name: "tpDashboardData",
      data: JSON.stringify({ tenantId: tenant_id }),
    })
  ).then(async (res) => {
    const parsedResponse = JSON.parse(res.data.getRdsData.response);
    return parsedResponse;
  });
};

export const getTenantInfo = async (email) => {
  return filterRDSDataFn("tnt", "email", email);
};

export const filterRDSDataFn = async (table, field, value) => {
  return API.graphql(
    graphqlOperation(getRdsData, {
      name: "tbSelect",
      data: JSON.stringify({ [field]: value, source: table }),
    })
  ).then(async (res) => {
    const parsedResponse = JSON.parse(res.data.getRdsData.response);
    return parsedResponse.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  });
};

export const checkvalidateTenant = async ({ email }) => {
  const parsedTenantInfo = await getTenantInfo(email);
  if (parsedTenantInfo && parsedTenantInfo.length > 0) {
    const querResposne = await API.graphql(
      graphqlOperation(validateTenant, {
        tenantId: parsedTenantInfo[0].id,
      })
    );
    return querResposne.data.validateTenant;
  } else {
    return { status: 404 };
  }
};

export const fetchSignedUrl = async (fileName, folderName) => {
  return API.graphql(
    graphqlOperation(getSignedUrl, {
      fileName: fileName,
      folderName: folderName,
      level: "public",
    })
  ).then((res) => res.data.getSignedUrl.response);
};

export const updateTenantFn = async (values) => {
  return updateRecordTB("Tenant", values);
};

export const saveUserInTenantGroup = async (awsUserId, awsUserPoolId) => {
  return API.graphql(
    graphqlOperation(addUserToGroup, {
      userName: awsUserId,
      userPoolId: awsUserPoolId,
    })
  );
};

export const getPublicTenantbyId = async (tenantId) => {
  const response = await accessToken();
  const res = await axios.post(
    `${envFile.PUBLIC_API_LINK}/findRecord`,
    { id: tenantId, table: "Tenant" },
    {
      headers: {
        Authorization: response.data.access_token,
      },
    }
  );
  return res.data;
};

export const changePasswordLogoutProcess = async (tenantId) => {
  const alllistChangePasswords = await getListChangePasswords();
  const isExit = alllistChangePasswords.find((item) => item.tenant_id === tenantId);
  if (isExit) {
    await updateRecordTB("ChangePassword", {
      updateChangePasswordInput: {
        id: isExit.id,
        last_modified: moment().format("YYYY-MM-DD h:mm:ss"),
      },
    });
  } else {
    await createRecordTB("ChangePassword", {
      id: getId(),
      // user_id: null,
      tenant_id: tenantId,
      created_at: moment().format("YYYY-MM-DD h:mm:ss"),
      last_modified: moment().format("YYYY-MM-DD h:mm:ss"),
    });
  }
};

export const getListChangePasswords = async () => {
  return API.graphql(graphqlOperation(listLambdaResolver, { table: "ChangePassword" })).then((response) =>
    JSON.parse(response.data.listLambdaResolver.response || "[]")
  );
};

export const listTenantCategoryFN = async () => {
  return API.graphql(graphqlOperation(listLambdaResolver, { table: "TenantCategory" })).then((response) =>
    JSON.parse(response.data.listLambdaResolver.response || "[]")?.filter((item) => item?.is_tp_visible === 1)
  );
};

export const crudCommunicationsEmailFN = async (payload) => {
  try {
    const res = await API.graphql(
      graphqlOperation(crudCommunications, {
        id: payload.id,
        role: payload.role,
        code: payload.code,
        data: JSON.stringify(payload.data),
        attachments: payload.attachments ? payload.attachments : null,
      })
    );
    // console.log("\n RES FROM EMAIL", res);
    return res.data.crudCommunications;
  } catch (err) {
    return {
      status: 500,
      message: "Something went wrong!",
    };
  }
};
